import Box from '@mui/material/Box';
import { AreaChart } from 'src/common/components/Graphs/common/Graphs/AreaChart';
import { useInventoryData } from './hooks/useInventoryData';
import { parseCompactNumber } from 'src/common/utils/parseCompactNumber';

type InventoryChartProps = {
  accountRef: string;
};

export const InventoryChart = ({ accountRef }: InventoryChartProps) => {
  const inventoryData = useInventoryData({ accountRef });

  return (
    <Box role="figure" aria-label="Inventory" sx={{ height: '100%' }}>
      <AreaChart
        datasets={inventoryData.datasets}
        xAxisLabels={inventoryData.xAxisLabels}
        pointRadius={0}
        yAxisLabel={inventoryData.yAxisLabel}
        tooltipValueFormatter={parseCompactNumber}
      />
    </Box>
  );
};
